const capitalizeString = (string: string) => {
  if (!string || !string[0] || !string[0].toUpperCase) return;

  return string[0].toUpperCase() + string.slice(1);
};

export default capitalizeString;
